import * as React from "react";

import { useTheme, Box, Stack, Typography, useMediaQuery } from "@mui/material";
import Marquee from "react-fast-marquee";

const TechnologySection = ({}) => {
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme.breakpoints.down(1000));

  const technologiesList = [
    {
      title: "HTML/SCSS/JS",
      image: "",
    },
    {
      title: "NodeJS/Express",
      image: "",
    },
    {
      title: "SocketIO",
      image: "",
    },
    {
      title: "Python",
      image: "",
    },
    {
      title: "Stripe Payments",
      image: "",
    },
    {
      title: "Java SE",
      image: "",
    },
    {
      title: "ReactJS/NextJS/React Native",
      image: "",
    },
    {
      title: "Microservices",
      image: "",
    },
    {
      title: "Chart and Gaphs",
      image: "",
    },
    {
      title: "UI & UX & System Design",
      image: "",
    },
    {
      title: "Financial Markets",
      image: "",
    },
  ];

  return (
    <Stack
      name={"master-techs"}
      sx={{
        bgcolor: theme.palette.common.white,
        py: "3rem",
        pb: smallScreen ? "3rem" : "5rem",
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Oswald', sans-serif",
          fontWeight: 700,
          fontSize: smallScreen ? "18px" : "32px",
          color: theme.palette.primary.main,
          textAlign: "center",
          px: "10vw",
          mb: smallScreen ? "1rem" : "2rem",
        }}
      >
        Mastered Technologies
      </Typography>
      <Marquee pauseOnHover={true} gradient={false} speed={20}>
        {technologiesList?.map((target) => {
          return (
            <Stack
              direction={"row"}
              sx={{
                alignItems: "center",
                px: smallScreen ? "1rem" : "2rem",
                py: smallScreen ? "0.7rem" : "1.5rem",
                bgcolor: theme.palette.common.white,
                mx: smallScreen ? "0.5rem" : "1.5rem",
                my: "1rem",
                borderRadius: "18px",
                boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 8%)",
                // boxShadow:
                //   "0px 8px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 88px -4px rgba(24, 39, 75, 0.14)",
              }}
            >
              {/* {target?.image} */}
              <Typography
                sx={{
                  color: theme.palette.common.black,
                  fontWeight: theme.typography.fontWeightRegular,
                  fontSize: "12px",
                  ml: "1rem",
                }}
              >
                {target?.title}
              </Typography>
            </Stack>
          );
        })}
      </Marquee>
    </Stack>
  );
};

export default TechnologySection;
